/**
 * Document icon assets
 * Importing images as assets ensures Vite processes them correctly
 * and they work with the base URL configuration
 */

// Import images as assets - Vite will process these correctly
import pdfIcon from './pdf_icon.svg';
import xlsIcon from './xls_icon.svg';
import jazzIcon1 from './jazz_special_icon_1.svg';
import loanOverviewIcon from './loan_overview.svg';
import propertyInformationIcon from './property_information.svg';
import borrowerProfileIcon from './borrower_profile.svg';
import employmentAndIncomeIcon from './employment_and_income.svg';
import equifaxLogo from './equifax_logo.png';
import transUnionLogo from './transUnion_logo.png';
import experianLogo from './experian_logo.png';
import cubeIcon from './cube.svg';
import creditPartnersLogo from '../images/credit-parters.svg';
import loanProgramIcon from './loan-program-icon.svg';
import footerIcon from './footer-icon.svg';
import aiStarIcon from './AI-star.svg';
import preApprovalIcon from './preApproval.svg';
import expandIcon from './Expand.svg';
import collapseIcon from './Collapse.svg';
import moneyBagIcon from './money-bag.svg';
import truvIcon from './truv-icon.svg';
import medalIcon from './medal.svg';
import borrowerHouseIcon from './borrow-house.svg';
import leadingElementIcon from './Leading element.svg';

import revolutionLogo from './revolution/logo.png';
import jazzxLogo from './jazzx/logo.png';
import revolutionProfileLogo from './revolution/profile_logo.png';

export const documentIcons = {
  pdf: pdfIcon,
  xls: xlsIcon,
  jazzIcon1: jazzIcon1,
  loanOverview: loanOverviewIcon,
  propertyInformation: propertyInformationIcon,
  borrowerProfile: borrowerProfileIcon,
  employmentAndIncome: employmentAndIncomeIcon,
  equifaxLogo: equifaxLogo,
  experianLogo: experianLogo,
  transUnionLogo: transUnionLogo,
  cube: cubeIcon,
  creditPartnersLogo: creditPartnersLogo,
  loanProgram: loanProgramIcon,
  revolutionLogo: revolutionLogo,
  footerIcon: footerIcon,
  aiStar: aiStarIcon,
  preApproval: preApprovalIcon,
  expand: expandIcon,
  collapse: collapseIcon,
  moneyBag: moneyBagIcon,
  truv: truvIcon,
  medal: medalIcon,
  borrowerHouse: borrowerHouseIcon,
  locationPin: leadingElementIcon,
} as const;

export const configIcons = {
  revolutionLogo: revolutionLogo,
  revolutionProfileLogo: revolutionProfileLogo,
  jazzxLogo: jazzxLogo,
};
export type ConfigIcons = keyof typeof configIcons;

export type DocumentIconType = keyof typeof documentIcons;
